// extracted by mini-css-extract-plugin
export default {"container":"Jackpot_container__VrTWI","dot":"Jackpot_dot__ym8u+","solid":"Jackpot_solid__+m6uT","currency":"Jackpot_currency__PYHv8"};